/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

const loadCollection = async () => {
  const collectionProducts = document.querySelector('.collection-products')
  const productList = collectionProducts.querySelector('.product-list')

  if (productList) {
    productList.style.opacity = '.2'
  }

  const response = await fetch(window.location.href)
  const data = await response.text()
  const parser = new DOMParser()
  const newDocument = parser.parseFromString(data, 'text/html')

  collectionProducts?.replaceWith(newDocument.querySelector('.collection-products'))

  document.querySelectorAll('.collection-filters-filter').forEach(elem => {
    elem?.replaceWith(newDocument.querySelector(`.collection-filters-filter[data-filter-label="${elem.dataset.filterLabel}"]`))
  })
  document.querySelectorAll('[data-collection-filter-label]').forEach(elem => {
    elem?.replaceWith(newDocument.querySelector(`[data-collection-filter-label][data-filter-label="${elem.dataset.filterLabel}"]`) || '')
  })
  document.querySelectorAll('.collection-product-count').forEach(elem => {
    elem?.replaceWith(newDocument.querySelector('.collection-product-count'))
  })
  document.querySelectorAll('.btn-filters-view-results').forEach(elem => {
    elem?.replaceWith(newDocument.querySelector('.btn-filters-view-results'))
  })
  document.querySelectorAll('.btn-filters-clear-all').forEach(elem => {
    elem?.replaceWith(newDocument.querySelector('.btn-filters-clear-all'))
  })

  window.dispatchEvent(new CustomEvent('kt.collection.loaded'))

  const newCollectionUtilities = document.querySelector('.collection-utilities')
  const newCollectionProducts = document.querySelector('.collection-products')

  if (newCollectionUtilities) {
    if (newCollectionUtilities.getBoundingClientRect().top < 0) {
      const headerHeight = document.querySelector('#header-group.sticky-top')?.clientHeight || 0
      newCollectionUtilities.style.scrollMarginTop = `${headerHeight}px`
    }
    newCollectionUtilities.scrollIntoView()
  } else {
    if (newCollectionProducts.getBoundingClientRect().top < 0) {
      const headerHeight = document.querySelector('#header-group.sticky-top')?.clientHeight || 0
      newCollectionProducts.style.scrollMarginTop = `${headerHeight}px`
    }
    newCollectionProducts.scrollIntoView()
  }
}

class CollectionFilters extends HTMLElement {
  constructor () {
    super()

    this.handleInputs()
    this.handleClearAllBtns()
    this.handlePriceSlider()

    window.addEventListener('kt.collection.loaded', () => {
      this.handleInputs()
      this.handleClearAllBtns()
      this.handlePriceSlider()
    })
  }

  handleInputs () {
    const form = this.querySelector('form')

    form.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        const params = new URLSearchParams(new FormData(form))
        const url = `${window.location.pathname}?${params.toString()}`
        window.history.replaceState({}, '', url)

        loadCollection()
      })
    })
  }

  handleClearAllBtns () {
    this.querySelectorAll('.btn-filters-clear-all').forEach(btn => {
      const params = new URLSearchParams(window.location.search)

      for (const key of params.keys()) {
        if (key.includes('filter.')) {
          btn.removeAttribute('hidden')
        }
      }

      btn.addEventListener('click', () => {
        for (const key of [...params.keys()]) {
          if (key.includes('filter.')) {
            params.delete(key)
          }
        }

        const url = `${window.location.pathname}?${params.toString()}`
        window.history.replaceState({}, '', url)
        loadCollection()
      })
    })
  }

  async handlePriceSlider () {
    const slider = this.querySelector('.filter-price-group-slider')
    if (!slider) return

    const link = document.createElement('link')
    link.setAttribute('href', slider.dataset.vendorCss)
    link.setAttribute('rel', 'stylesheet')
    document.head.appendChild(link)

    const script = document.createElement('script')
    script.setAttribute('src', slider.dataset.vendorJs)
    document.head.appendChild(script)

    if (!window.noUiSlider) {
      await new Promise(resolve => setTimeout(resolve, 1000))
    }

    const minValueField = slider.closest('form').querySelector('[name="filter.v.price.gte"]')
    const maxValueField = slider.closest('form').querySelector('[name="filter.v.price.lte"]')

    window.noUiSlider.create(slider, {
      start: [
        Number(slider.dataset.minValue),
        Number(slider.dataset.maxValue)
      ],
      connect: true,
      range: {
        min: Number(slider.dataset.rangeMin),
        max: Number(slider.dataset.rangeMax)
      },
      step: 1
    })

    slider.noUiSlider.on('update', function (values) {
      minValueField.value = values[0]
      maxValueField.value = values[1]
    })

    slider.noUiSlider.on('change', function () {
      const event = new Event('change')
      minValueField.dispatchEvent(event)
      maxValueField.dispatchEvent(event)
    })
  }
}
customElements.define('collection-filters', CollectionFilters)

class SortBy extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        this.setUrl(input.value)
        loadCollection()
      })
    })
  }

  setUrl (value) {
    const params = new URLSearchParams(window.location.search)
    params.set('sort_by', value)
    params.delete('page')
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)
  }
}
customElements.define('sort-by', SortBy)

class Pagination extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('a').forEach(elem => {
      elem.addEventListener('click', (event) => {
        event.preventDefault()

        this.setUrl(elem.dataset.newPage)
        loadCollection()
      })
    })
  }

  setUrl (value) {
    const params = new URLSearchParams(window.location.search)
    params.set('page', value)
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)
  }
}
customElements.define('collection-pagination', Pagination)
